import script from "./EditSystemAlerts.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSystemAlerts.vue?vue&type=script&setup=true&lang=js"

import "./EditSystemAlerts.vue?vue&type=style&index=0&id=56d7c24f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d7c24f"]])

export default __exports__